import React from 'react';
import { motion } from 'framer-motion';
import Constants from '../../../app/utils/constants'

const FeatureSection = () => {
  const { portfolioFeatureItems } = Constants

  return (
    <section className="mx-auto mt-10 md-mt-20 w-full max-w-[90%] pb-20 text-white">

      {/* 🔥 BORDER ANIMATION STYLE */}
      <style>{`
.card-border {
  position: relative;
  border-radius: 1rem;
  padding: 1px;
  overflow: hidden;
}

/* REAL BORDER LAYER */
.card-border::before {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: inherit;

  background: linear-gradient(
    170deg,
    #000000 0%,
    #000000 55%,
    #8FE64A 90%,
    #8FE64A 100%
  );

  z-index: 0;
}

/* INNER CONTENT */
.card-border > div {
  position: relative;
  z-index: 1;
  border-radius: inherit;
  background: black;
}

/* 🔥 ANIMATION ON HOVER */
.card-border:hover::before {
  animation: rotateGradient 5s linear infinite;
}

/* ROTATION */
@keyframes rotateGradient {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
`}</style>

      {/* HEADING */}
      <div className="flex items-center justify-center gap-4 mb-16 ">

        {/* LEFT LINE */}
        <motion.div
          initial={{ x: -150, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: false }}
          transition={{ duration: 0.6, ease: 'easeIn' }}
          className="flex items-center mt-4"
        >
          <span className="w-2 h-2 bg-[#8FE64A] rounded-full"></span>
          <div className="w-12 md:w-30 h-px bg-gray-100"></div>
        </motion.div>

        {/* HEADING */}
        <motion.h2
          initial={{ scale: 0.6, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          viewport={{ once: false }}
          transition={{ duration: 0.6, ease: 'easeIn' }}
          className="text-4xl md:text-5xl lg:text-6xl font-bold font-gilroy text-[#8FE64A]"
        >
          Features
        </motion.h2>

        {/* RIGHT LINE */}
        <motion.div
          initial={{ x: 150, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          viewport={{ once: false }}
          transition={{ duration: 0.6, ease: 'easeIn' }}
          className="flex items-center mt-4"
        >
          <div className="w-12 md:w-30 h-px bg-gray-100"></div>
          <span className="w-2 h-2 bg-[#8FE64A] rounded-full"></span>
        </motion.div>

      </div>

      {/* GRID */}
      <div className="grid grid-cols-2 gap-4 md:gap-8 auto-rows-fr">
        {portfolioFeatureItems.map((item, idx) => {
          const num = String(idx + 1).padStart(2, '0');

          const isLeft = idx % 2 === 0;

          return (
            <motion.div
  key={idx}
  className="h-full"
  initial={{ x: isLeft ? -50 : 50, opacity: 0 }}
  whileInView={{ x: 0, opacity: 1 }}
  viewport={{ once: false, margin: '-50px' }}
  transition={{ duration: 0.6, ease: 'easeIn' }}
>

              {/* CARD BORDER */}
              <div className="card-border h-full">
  <div className="h-full min-h-[180px] w-full rounded-2xl bg-black flex flex-col justify-center px-4 py-4 md:px-8 md:py-6 lg:px-8 lg:py-8 xl:px-8 2xl:px-12 2xl:py-12">

  <div className="flex h-full flex-col justify-start gap-4 md:gap-6">
      <span className="shrink-0 font-gilroy-bold text-4xl text-[#8FE64A]/90 md:text-4xl">
        {num}
      </span>

      <h3 className="pt-1 text-left font-gilroy-medium text-base text-white md:text-2xl lg:text-3xl">
        {item.title}
      </h3>
    </div>

  </div>
</div>

            </motion.div>
          );
        })}
      </div>

    </section>
  );
};

export default FeatureSection;